export enum AxiosRequestMethod {
  GET = 'get',
  POST = 'post'
}
